import * as React from "react";

/**
 * A hook that returns true _after_ the first render in the browser. If `true`
 * is returned, then things like `window` should be defined.
 *
 * This is a replacement for checks like `typeof window !== "undefined"` and
 * will will prevent hydration mismatches.
 */
export function useHasHydrated() {
  const [hasHydrated, setHasHydrated] = React.useState(false);

  React.useEffect(() => {
    setHasHydrated(true);
  }, []);

  return hasHydrated;
}
